module.exports = __webpack_public_path__ + "img/foodsafety_info.e2627767.png";